import React from 'react';

const LaneGValiante = (
    <>
    <p>Lane leads our marketing strategy and communications initiatives.  Lane has had a successful career in marketing, strategy development, digital marketing and communications.  With her firm, LGV Creative, she has assisted many organizations in cost-effectively reaching and retaining their customers.  For Symphony, Lane has redesigned our marketing focus and website, sharpened our messaging, identified key channels for sales and strengthened the execution of our marketing.  She has a strong foundation in healthcare, having previously served as Director of Communications for Teton Valley Health in Driggs, Idaho.  Lane is a graduate of Centre College with a BA degree.</p>
    </>
  );

export default LaneGValiante;